const validation = {
  name: {
    presence: {
      message: '^validation.tab.nameIsMandatory'
    }
  },
};

export default validation;
